// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__23Bf4","title":"Header_title__1cAQe","side":"Header_side__1LMTO"};